import React from 'react';
import LegalPage from './LegalPage';

export default function DeleteAccount() {
  return <LegalPage pageKey="deleteAccount" />;
}
